export function roundTo(decimalPlace: number, num: number): number {
  const pow = Math.pow(10, decimalPlace);
  return Math.round(num * pow) / pow;
}

export function clamp(min: number, value: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
